import React, { useState } from "react";
import "./style/Popup.css";

const Popup = ({ isOpen, onClose, onSubmit }) => {
  const [workspaceName, setWorkspaceName] = useState("");
  const [apiKey, setApiKey] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (workspaceName.trim() === "" || apiKey.trim() === "") return;

    onSubmit(workspaceName, apiKey);

    setWorkspaceName("");
    setApiKey("");
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup">
        <h3>Add New Workspace</h3>
        <input
          type="text"
          placeholder="Workspace Name"
          value={workspaceName}
          onChange={(e) => setWorkspaceName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Weather API Key"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
        />
        <div className="buttons">
          <button className="popup__button" onClick={handleSubmit}>Submit</button>
          <button className="popup__button-cancel" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
